<script>
import ThumbnailList from './src/ThumbnailList';
export default ThumbnailList;
</script>